import { render } from "./UEWriteOffListView.vue?vue&type=template&id=b5508e9e&scoped=true"
import script from "./UEWriteOffListView.vue?vue&type=script&lang=js"
export * from "./UEWriteOffListView.vue?vue&type=script&lang=js"

import "./UEWriteOffListView.vue?vue&type=style&index=0&id=b5508e9e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5508e9e"]])

export default __exports__